import ElementConfig from '../classes/definitions/formItem/ElementConfig';
import FormItem from '../classes/definitions/formItem/FormItem';
var optionTypeSchema = {
    bg_name: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
        }),
        elementType: 'input',
        label: 'Име на български *',
        value: '',
        validation: {
            required: true
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въвдете валидно име на български',
    }),
    en_name: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
        }),
        elementType: 'input',
        label: 'Име на английски *',
        value: '',
        validation: {
            required: true
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въвдете валидно име на английски',
    }),
    display_type: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control category-dropdown',
            placeholder: '',
            options: []
        }),
        elementType: 'dropdown',
        label: 'Тип *',
        validation: {
            required: true
        },
        value: '',
        valid: false,
        touched: false,
        hidden: true
    }),
};
export default optionTypeSchema;



//////////////////
// WEBPACK FOOTER
// ./src/schemas/optionTypeSchema.ts
// module id = 376
// module chunks = 0